// Who may use the Companies area. Super Admin (role 1, including role_members, plus the
// app's god-mode ids) sees and manages every company; a company manager
// (company_access.is_manager) only the companies they manage. The API enforces the same.
import { isLeaveSuperAdmin } from '@/components/leave-management/leaveUtils';

export function isCompanySuperAdmin(user) {
    if (!user) return false;
    if (isLeaveSuperAdmin(user)) return true;
    return Array.isArray(user.role_members) && user.role_members.some((m) => Number(m.user_role_id) === 1);
}

// Company ids the user is marked as manager of, from the users() provider (carries access[]).
export function manageableCompanyIds(user, usersList = []) {
    const record = (usersList || []).find((u) => Number(u.id) === Number(user && user.id)) || user || {};
    return new Set((record.access || []).filter((a) => a.is_manager).map((a) => Number(a.company_id)));
}

// Editing the company record itself (Edit Company): Super Admin only (role 1, incl.
// role_members, + god-mode ids). Admins and company managers manage members, not the
// company's details. Mirrors the API.
export function canEditCompanyDetails(user) {
    if (!user) return false;
    if (user.role_id === 1 || [1, 177, 145].includes(user.id)) return true;
    return Array.isArray(user.role_members) && user.role_members.some((m) => Number(m.user_role_id) === 1);
}

export function canManageCompanyPage(user, usersList, companyId) {
    return isCompanySuperAdmin(user) || manageableCompanyIds(user, usersList).has(Number(companyId));
}
